import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../store/store';
import { fetchPayers, clearPayers } from '../store/payersSlice';

const usePayers = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { payers, loading, error } = useSelector(
    (state: RootState) => state.payers,
  );
  const { selectedHospital } = useSelector(
    (state: RootState) => state.hospitals,
  );

  useEffect(() => {
    if (selectedHospital?.tenantId) {
      // Always fetch payers when component mounts - fresh data every time
      dispatch(fetchPayers(selectedHospital.tenantId));
    } else {
      // Clear payers if no hospital is selected
      dispatch(clearPayers());
    }
  }, [dispatch, selectedHospital?.tenantId]);

  const refetchPayers = () => {
    if (selectedHospital?.tenantId) {
      dispatch(fetchPayers(selectedHospital.tenantId));
    }
  };

  return {
    payers,
    loading,
    error,
    refetchPayers,
  };
};

export default usePayers;
